var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6.1196e-07C6.76917 6.32139e-07 6.55027 0.102277 6.4025 0.279167L0.180293 7.72743C-0.0947001 8.05661 -0.0501139 8.54584 0.279877 8.82015C0.60987 9.09447 1.10031 9.04999 1.3753 8.72081L7 1.98779L12.6247 8.72081C12.8997 9.04999 13.3901 9.09447 13.7201 8.82015C14.0501 8.54583 14.0947 8.0566 13.8197 7.72743L7.5975 0.279167C7.44973 0.102277 7.23083 5.9178e-07 7 6.1196e-07Z",
    fill: "#2D1664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragTop);
export default __webpack_public_path__ + "static/media/drag-top.bab880f020e43d48f79bd5980f79835b.svg";
export { ForwardRef as ReactComponent };